import React, { Component } from 'react';
import { connect } from 'react-redux'
import styled from 'styled-components';
import 'whatwg-fetch';
import queryString from 'query-string';
import { MainLayout, ResultLayout } from './html/layouts';
import { sendData } from './services';

const urlSharer = process.env.REACT_APP_SHARER_URL || '/db/share.php';
const Wrapper = styled.div`

`;

export class App extends Component {
	componentDidMount() {
		document.title = 'Cost of absenteeism calculator';
	}
	onSubmit = async () => {
		const { results, data: { submitForm, ...data } } = this.props;
		console.info('saveToPdf');
		const resultData = { ...results, ...data, ...submitForm };
		const sendData = Object.keys(resultData).reduce((result, name) => ({ ...result, [name]: resultData[name] }), {});
		window.open(`${urlSharer}?${queryString.stringify(sendData)}`);
		return true;
	}
	onSubmitOld = async () => {
		console.info('onSubmit');
		const { submitForm: { yourName: firstName, yourLastName: lastName }, submitForm = {}, ...data } = this.props.data;
		this.props.onLoad(true);
		await this.props.onSubmit();
		if (!this.props.errorMessages.length) {
			const result = await sendData('/db', '/', { ...data, ...submitForm, firstName, lastName });
			if (!result.length) {
				await this.saveToPdf();
				this.props.clearSubmitForm();
			}
		}
		this.props.onLoad(false);
	};
	render() {
		return (
			<Wrapper>
				<MainLayout {...{ ...this.props, onSubmit: this.onSubmit }} />
				<div style={{ position: 'absolute' }} >
					<ResultLayout {...{ ...this.props, onSubmit: this.onSubmit }} />
				</div>
			</Wrapper>
		);
	}
};

const mapStateToProps = ({ calculator, routing }) => ({ ...calculator, routing });

const mapDispatchToProps = dispatch => ({
  onChange: (data) => {
		dispatch({ type: 'ON_CHANGE', payload: data });
  },
	onLoad: (isLoading) => {
		dispatch({ type: 'ON_LOAD', payload: isLoading });
  },
	onSubmit: () => {
		dispatch({ type: 'ON_SUBMIT' });
  },
	clearSubmitForm: () => {
		dispatch({ type: 'CLEAR_SUBMIT_FORM' });
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js